import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cutter',
  standalone: false,
})
export class CutterPipe implements PipeTransform {

  transform(input: string, len: number) {
    let size    = len;
    let output  = input;
    let suffix  = '…';
    let b       = 0;
    for (let i = 0 ; i < output.length ; i++) {
      b += output.charCodeAt(i) <= 255 ? 0.5 : 1;
      if (b > size) {
        output = output.substr(0, i) + suffix;
        break;
      }
    }
    return output;
  }

}
